import React from 'react';

function DateInput(props: any, ref: any) {
  return <input ref={ref} {...props} readOnly />;
}

export default React.forwardRef(DateInput);
